import React from 'react';
import '../Section10/component.css';

const Section15 = () => {
  return (
    <div className="svc-intro" style={{ paddingTop: '0px', borderBottom: 'none' }}>
      <div className="svc-intro-inner">
        <div className="svc-details">
          <h3 className="svc-intro-title">Why Choose Hypertonic</h3>

          <div className="svc-feature">
            <h4>Expertise</h4>
            <p className="svc-intro-body">With years of experience in the mobile app development industry, our team possesses the technical skills and creative vision to develop cutting-edge apps that stand out.</p>
          </div>

          <div className="svc-feature">
            <h4>Cross-Platform Compatibility</h4>
            <p className="svc-intro-body">We understand the importance of reaching a wider audience. Whether your target users are on Android or iOS devices, we develop apps that perform seamlessly on both platforms.</p>
          </div>

          <div className="svc-feature">
            <h4>Custom Solutions</h4>
            <p className="svc-intro-body">We believe in tailor-made solutions that cater to the unique needs of each client. From small startups to large enterprises, we work closely to deliver custom app solutions.</p>
          </div>

          <div className="svc-feature">
            <h4>User-Centric Design</h4>
            <p className="svc-intro-body">We place a strong emphasis on UX/UI design to ensure your app not only looks great but inherently provides a seamless and intuitive user experience that maximizes engagement.</p>
          </div>

          <div className="svc-feature">
            <h4>24*7 Service</h4>
            <p className="svc-intro-body">Whether it's the middle of the night or a holiday weekend, our team is here for you 24 hours a day, 7 days a week, whenever you need assistance.</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Section15;
